<div id="wrapper" class="no-select">


  <div id="cordinates" *ngIf="currentCoordinate; else noCoordinate">
    <div>{{C1}}: {{currentCoordinate!.coordX}}</div>
    <div>{{C2}}: {{currentCoordinate!.coordY}}</div>
  </div>
  <ng-template #noCoordinate>
    <div id="cordinates">
      <div>{{C1}}: -</div>
      <div>{{C2}}: -</div>
    </div>
  </ng-template>

  <svg-icon src="./icon/target.svg" [svgStyle]="{
    width: '24',
    height: '24',    
  }"></svg-icon>

</div>